import { createSlice } from "@reduxjs/toolkit";

const initialTopUpState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  topUpForEdit: undefined,
  lastError: null,
  invoiceTopUpInvoiceList: [],
  detailInvoice: {},
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const topUpSlice = createSlice({
  name: "topUp",
  initialState: initialTopUpState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getTopUpById
    topUpFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.topUpForEdit = action.payload.topUpForEdit;
      state.detailInvoice = action.payload.detailInvoice;
    },
    // findTopUp
    topUpsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.invoiceTopUpInvoiceList = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    topUpReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
